module.exports = __webpack_public_path__ + "static/media/repeatingBackground.c608f23f.svg";